var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('particles-bg',{staticStyle:{"backgroundColor":"#23263a","width":"100%","height":"110vh"},attrs:{"num":"30","type":"cobweb","bg":true}}),_c('gallery',{staticClass:"gl",attrs:{"url":_vm.url,"title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }